import type {UserFeedback} from '../types'

export const toFeedbackRequestBody = (userFeedback: UserFeedback, sharingKey: string) => {
  const {score, comment, reasonIDs} = userFeedback
  const reasons = reasonIDs?.map(reasonID => ({reason_id: reasonID}))

  return {key: sharingKey, score, comment, reasons}
}
